"use client";

import { c as _c } from "react/compiler-runtime";
import { deleteReview } from "@/actions/course-review";
import { ReviewCard } from "@/components/card/review-card";
import { AlertDialog, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import ButtonWithLoader from "@/components/utility/button-with-loader";
import { TUserReview } from "@/types/types";
import { tryCatch } from "@/utils/validators";
import { format } from "date-fns";
import { EllipsisVertical } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../ui/dropdown-menu";
type ManageReviewProps = {
  review: TUserReview;
};
export default function ManageReview(t0) {
  const $ = _c(26);
  const {
    review
  } = t0;
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const t1 = review.user.profile?.firstName || "";
  const t2 = review.user.profile?.lastName || "";
  const t3 = review.user.username || "";
  const t4 = review.user.profile?.imageUrl || "";
  const t5 = review.description || "";
  const t6 = review.rating;
  let t7;
  if ($[0] !== review.reviewedAt) {
    t7 = format(review.reviewedAt, "yyyy-MM-dd");
    $[0] = review.reviewedAt;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  let t8;
  if ($[2] !== review.rating || $[3] !== t1 || $[4] !== t2 || $[5] !== t3 || $[6] !== t4 || $[7] !== t5 || $[8] !== t7) {
    t8 = {
      firstName: t1,
      lastName: t2,
      username: t3,
      userImageUrl: t4,
      reviewText: t5,
      rating: t6,
      reviewedAt: t7
    };
    $[2] = review.rating;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const reviewFormatted = t8;
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = async function handleDelete(reviewId) {
      setIsDeleting(true);
      const {
        error
      } = await tryCatch(deleteReview(reviewId));
      if (error) {
        toast.error(error.message);
        setIsDeleting(false);
        return;
      }
      setIsDeleting(false);
      setIsDeleteDialogOpen(false);
      toast.success("Review deleted.");
    };
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const handleDelete = t9;
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <DropdownMenuTrigger className="p-1"><EllipsisVertical size={16} /></DropdownMenuTrigger>;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <DropdownMenu>{t10}<DropdownMenuContent><DropdownMenuItem onClick={() => setIsDeleteDialogOpen(true)}>Delete</DropdownMenuItem></DropdownMenuContent></DropdownMenu>;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <AlertDialogHeader><AlertDialogTitle>Are you absolutely sure?</AlertDialogTitle><AlertDialogDescription>This action cannot be undone. It will permanently delete this review.</AlertDialogDescription></AlertDialogHeader>;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <AlertDialogCancel>Cancel</AlertDialogCancel>;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] !== review.id) {
    t14 = () => handleDelete(review.id);
    $[15] = review.id;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  let t15;
  if ($[17] !== isDeleting || $[18] !== t14) {
    t15 = <AlertDialogContent>{t12}<AlertDialogFooter>{t13}<ButtonWithLoader pending={isDeleting} onClick={t14}>Delete</ButtonWithLoader></AlertDialogFooter></AlertDialogContent>;
    $[17] = isDeleting;
    $[18] = t14;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== isDeleteDialogOpen || $[21] !== t15) {
    t16 = <div className="absolute right-3 top-3">{t11}<AlertDialog open={isDeleteDialogOpen} onOpenChange={setIsDeleteDialogOpen}>{t15}</AlertDialog></div>;
    $[20] = isDeleteDialogOpen;
    $[21] = t15;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] !== reviewFormatted || $[24] !== t16) {
    t17 = <><ReviewCard review={reviewFormatted} className="relative w-full bg-background shadow-sm dark:shadow-none">{t16}</ReviewCard></>;
    $[23] = reviewFormatted;
    $[24] = t16;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  return t17;
}

// Recycled

// const reviewCleaned = {
//   name: `${userReview.user.profile?.firstName} ${userReview.user.profile?.lastName}`,
//   username: `@${userReview.user.profile?.firstName?.toLocaleLowerCase()}_${userReview.user.profile?.lastName?.toLocaleLowerCase()}`,
//   reviewText: userReview.description || "",
//   rating: userReview.rating,
//   imageUrl: userReview.user.profile?.imageUrl || "",
// };